import { MetricsDashboard } from "@/components/MetricsDashboard";

export default function MetricsPage() {
  return <MetricsDashboard />;
}